export default "__VITE_ASSET___fkSyFMH__"